// Panel for mobile
const $menuButtons = document.querySelectorAll(".js-menu-button");
const $menu = document.querySelector(".js-navigation");
const desktopQuery = window.matchMedia("(min-width: 1200px)");

/**
 * Fonction pour fermer la navigation mobile
 * Résout le problème où la navigation reste ouverte après connexion/redirection
 */
function closeMobileNavigation() {
    /* if ($menu && $menu.classList.contains("active")) {
        $menu.classList.remove("active");
        document.body.style.overflow = "auto";
    } */
}

$menuButtons.forEach(($menuButton) => {
    if ($menu)
        $menuButton.addEventListener("click", () => {
            $menu.classList.add("has-interacted");
            if ($menu.classList.contains("active")) {
                document.body.style.overflow = "auto";
            } else {
                document.body.style.overflow = "hidden";
            }
            $menu.classList.toggle("active");
        });
});

// Fermer la navigation lors des redirections/navigations
document.addEventListener("DOMContentLoaded", () => {
    closeMobileNavigation();
});

// Fermer la navigation lors des navigations Livewire (si utilisé)
document.addEventListener("livewire:navigated", () => {
    closeMobileNavigation();
});

// Fermer la navigation lors des changements d'URL (pour les SPAs ou redirections)
window.addEventListener("beforeunload", () => {
    closeMobileNavigation();
});

// Fermer la navigation lors des navigations avec l'API History
window.addEventListener("popstate", () => {
    closeMobileNavigation();
});

// Fermer la navigation lors des clics sur les liens internes
document.addEventListener("click", (event) => {
    const link = event.target.closest("a");
    if (
        link &&
        link.href &&
        !link.href.startsWith("javascript:") &&
        !link.href.startsWith("#")
    ) {
        // Vérifier si c'est un lien interne ou externe
        const currentDomain = window.location.origin;
        const linkDomain = new URL(link.href, window.location.origin).origin;

        // Si c'est un lien interne, fermer la navigation
        if (linkDomain === currentDomain) {
            closeMobileNavigation();
        }
    }
});

let navResizeTimer;
window.addEventListener("resize", () => {
    clearTimeout(navResizeTimer);
    navResizeTimer = setTimeout(() => {
        if (desktopQuery.matches && $menu) {
            $menu.classList.remove("active", "has-interacted");
            document.body.style.overflow = "auto";
        }
    }, 200);
});

// Menu items
const $menuItems = document.querySelectorAll(
    '.js-navigation-item[data-has-children="true"]',
);
$menuItems.forEach(($menuItem) => {
    const $link = $menuItem.querySelector("a");
    const $back = $menuItem.querySelector(".navigation-item__back");
    const handleClickOutside = function (e) {
        if (!$menuItem.contains(e.target)) {
            $menuItem.classList.remove("active");
        }
    };

    if ($link)
        $link.addEventListener("click", (event) => {
            event.preventDefault();
            if ($menuItem.classList.contains("active")) {
                window.removeEventListener("click", handleClickOutside);
            } else {
                window.addEventListener("click", handleClickOutside);
            }
            $menuItem.classList.toggle("active");
        });
    if ($back)
        $back.addEventListener("click", (event) => {
            event.preventDefault();
            $menuItem.classList.remove("active");
        });
});
